export default {
  'finance.instructionsLanguage': 'Language',
  'finance.operationTime': 'Operate Time',
  'finance.operation': 'Operate',
  'finance.accountId': 'User ID',
  'finance.withdrawal': 'Withdrawal',
  'finance.deposit': 'Deposit',
  'finance.amount': 'Amount',
  'finance.enterAmount': 'Please keyin amount',
  'finance.amountMustBeGreaterThanZero': 'Amount must be > 0',
  'finance.enterAccountToQuery': 'Enter User ID',
  'finance.hint': 'Tips',
  'finance.rejectWithdrawalApplication': 'Reject withdrawal application?',
  'finance.applicationRejected': 'Rejected application',
  'finance.manualWithdrawalDeductBalance':
    "Select manual withdrawal will deduct user's balance, confirm?",
  'finance.manualWithdrawalExecuted': 'Performed manual withdrawal',
  'finance.selectWithdrawalChannel': 'Select withdrawal channel',
  'finance.withdrawalChannel': 'Withdrawal Channel',
  'finance.selectChannelFirst': 'Select withdrawal channel',
  'finance.autoWithdrawalExecuted': 'Auto withdrawal approved',
  'finance.date': 'Date',
  'finance.orderNumber': 'Order Number',
  'finance.phoneAccountId': 'Phone / User ID',
  'finance.currency': 'Currency',
  'finance.totalWithdrawal': 'Total Withdrawal',
  'finance.walletName': 'Wallet Name',
  'finance.accountNumber': 'Account Number',
  'finance.withdrawalAmount': 'Withdrawal Number',
  'finance.withdrawalStatus': 'Withdrawal Status',
  'finance.time': 'Time',
  'finance.internalRemark': 'Internal Remark',
  'finance.rejectReason': 'Rejection Reason',
  'finance.rejectReasonMemberVisible': 'Rejection Reason (visible to member)',
  'finance.withdrawing': 'Withdrawing',
  'finance.applying': 'Applying',
  'finance.withdrawn': 'Approved',
  'finance.manualWithdrawn': 'Manual Withdrawal',
  'finance.returned': 'Rejected',
  'finance.applicationPending': 'Applying',
  'finance.withdrawalInProgress': 'Withdrawing',
  'finance.withdrawalCompleted': 'Approved',
  'finance.withdrawalReturned': 'Rejected',
  'finance.exceptionOrder': 'Exception Order',
  'finance.manualWithdrawal': 'Manual Withdrawal',
  'finance.autoWithdrawal': 'Auto Withdrawal',
  'finance.applicationTime': 'Application Time',
  'finance.settlementTime': 'Settled Time',
  'finance.lock': 'Lock',
  'finance.review': 'Review',
  'finance.beingReviewedBy': 'Reviewed by {user}',
  'finance.unlock': 'Unlock',
  'finance.activate': 'Reactivate',
  'finance.withdrawnCompleted': 'Approved',
  'finance.confirmThirdPartyStatus':
    'Please reconfirm withdrawal status with the withdrawal system provider, or else duplicate withdrawal might occur!',
  'finance.fuzzyQuery': 'Fuzzy Query',
  'finance.reset': 'Reset',
  'finance.withdrawalReview': 'Review application',
  'finance.confirmLock': 'Are you sure you want to lock this item?',
  'finance.confirmUnlock': 'Are you sure you want to unlock this item?',
  'finance.confirmActivate': 'Are you sure you want to activate this item?',
  'finance.balance': 'Balance',
  'finance.enterWithdrawalAmount': 'Please enter withdrawal amount',
  'finance.enterMark': 'Please enter remark',

  'finance.whetherUser': 'Whether to apply to this user',

  'finance.withdrawalRequestDetails': 'Withdrawal Request Details',
  'finance.memberInformation': 'Member Information',
  'finance.previousWithdrawalTime': 'Previous Withdrawal Time',
  'finance.historicalTotalWithdrawals':
    'Historical total withdrawals {count} times, total {currency}{amount}',
  'finance.memberRegistrationTime': 'Member Registration Time',
  'finance.todayTotalWithdrawals': 'Today total withdrawals {count} times, total {amount}',
  'finance.orderInformation': 'Order Information',
  'finance.payoutChannel': 'Payout Channel',
  'finance.withdrawalInformation': 'Withdrawal Information',
  'finance.copiedToClipboard': 'Copied to clipboard',
  'finance.copyFailed': 'Copy failed',
  'finance.copyEmpty': 'Content empty, cannot copy',

  'payoutChannel.title': 'Withdrawal Channel',
  'payoutChannel.withdrawChannel': 'Withdrawal Channel',
  'payoutChannel.withdrawType': 'Withdrawal Type',
  'payoutChannel.channelStatus': 'Channel Status',
  'payoutChannel.walletName': 'Wallet Name',
  'payoutChannel.operation': 'Operation',
  'payoutChannel.merchantName': 'Merchant Name',
  'payoutChannel.merchantCode': 'Merchant Code',
  'payoutChannel.deleteConfirm': 'Are you sure you want to delete this item?',
  'payoutChannel.operationSuccessful': 'Operation Successful',

  // CreateTemplateForm - Title
  'payoutChannel.form.title.add': 'Add Withdrawal Channel',
  'payoutChannel.form.title.edit': 'Edit Withdrawal Channel',
  // CreateTemplateForm - Labels
  'payoutChannel.form.labels.withdrawChannel': 'Withdrawal Channel',
  'payoutChannel.form.labels.merchantName': 'Merchant Name',
  'payoutChannel.form.labels.walletName': 'Wallet Name',
  'payoutChannel.form.labels.merchantCode': 'Merchant Code',
  'payoutChannel.form.labels.secretKey': 'Secret Key',
  'payoutChannel.form.labels.publicKey': 'Public Key',
  'payoutChannel.form.labels.privateKey': 'Private Key',
  'payoutChannel.form.labels.payUrl': 'Pay URL',
  'payoutChannel.form.labels.withdrawLimit': 'Withdraw Limit',
  'payoutChannel.form.labels.minAmount': 'Min Amount',
  'payoutChannel.form.labels.maxAmount': 'Max Amount',

  // CreateTemplateForm - Placeholders
  'payoutChannel.form.placeholders.selectWithdrawChannel': 'Please select withdrawal channel',
  'payoutChannel.form.placeholders.enterMerchantName': 'Please enter merchant name',
  'payoutChannel.form.placeholders.selectWalletName': 'Please select wallet name',
  'payoutChannel.form.placeholders.enterMerchantCode': 'Please enter merchant code',
  'payoutChannel.form.placeholders.enterSecretKey': 'Please enter secret key (optional)',
  'payoutChannel.form.placeholders.enterPublicKey': 'Please enter public key (optional)',
  'payoutChannel.form.placeholders.enterPrivateKey': 'Please enter private key (optional)',
  'payoutChannel.form.placeholders.enterPayUrl': 'Please enter pay URL',
  'payoutChannel.form.placeholders.enterSort': 'Please enter sort',
  'payoutChannel.form.placeholders.enterMinAmount': 'Please enter min amount',
  'payoutChannel.form.placeholders.enterMaxAmount': 'Please enter max amount',
  'payoutChannel.form.placeholders.enterRemark': 'Please enter remark',

  // CreateTemplateForm - Validation
  'payoutChannel.form.validation.withdrawChannelRequired': 'Please select withdrawal channel',
  'payoutChannel.form.validation.merchantNameRequired': 'Please enter merchant name',
  'payoutChannel.form.validation.walletNameRequired': 'Please select wallet name',
  'payoutChannel.form.validation.merchantCodeRequired': 'Please enter merchant code',
  'payoutChannel.form.validation.sortRequired': 'Please enter sort',
  'payoutChannel.form.validation.minAmountRequired': 'Please enter min amount',
  'payoutChannel.form.validation.maxAmountRequired': 'Please enter max amount',
  'payoutChannel.form.validation.maxAmountMustBeGreaterThanMinAmount':
    'Max amount must be greater than or equal to min amount',

  // CreateTemplateForm - Messages
  'payoutChannel.form.messages.to': 'to',
  'payoutChannel.form.messages.optional': '(optional)',

  'finance.confirmWithdraw1':
    'Mangyaring pumunta sa third-party upang kumpirmahin ang status ng pag-withdraw ng order na ito, kung hindi ay maaaring magkaroon ng duplicate na payout!',
  'finance.confirmWithdraw2':
    'Kung kumpirmadong hindi pa na-withdraw, mangyaring i-click ang [Activate] button para baguhin ang status ng order sa "Hindi pa na-withdraw"',
  'finance.confirmWithdraw3':
    'Kung kumpirmadong na-withdraw na, mangyaring i-click ang [Na-withdraw Na] button para baguhin ang status ng order sa "Na-withdraw Na"',
  'finance.rejectReason.readable': 'Member can read reject reason',
  'finance.rejectReasonNotAllowed':
    'When reject reason is filled in, only reject button is allowed',

  // Withdrawal restriction
  'finance.update': 'Update',
  'finance.withdrawLimitTitle': 'Withdrawal Limit',
  'finance.withdrawLimitInviteTitle': 'Number of Invitations (Increment)',
  'finance.withdrawLimitInviteDesc':
    'Cumulative successful invitations: this withdrawal request − last withdrawal request ≥:',
  'finance.withdrawLimitCountDesc': 'Count: the required increment of invitations at withdrawal.',
  'finance.withdrawLimitRange': 'Please enter an integer between 0 and 999',
  'finance.withdrawLimitInviteRequired': 'Please enter the cumulative successful invitations',
  'finance.withdrawLimitAmount': 'Amount',
  'finance.withdrawLimitCount': 'Count',
  'finance.withdrawLimitAmountPlaceholder': 'Please enter the amount',
  'finance.withdrawLimitCountPlaceholder': 'Please enter the count',
  'finance.withdrawLimitAmountRequired': 'Please enter the amount',
  'finance.withdrawLimitAmountRange': 'Please enter an integer between 1 and 99999',
  'finance.withdrawLimitCountRequired': 'Please enter the count',
  'finance.withdrawLimitAdd': 'Add',
  'finance.withdrawLimitFreeRegisterPrefix': 'No limit: within',
  'finance.withdrawLimitFreeRegisterSuffix': 'hours after registration',
  'finance.withdrawLimitFreeRegisterRequired': 'Please enter the hours',
  'finance.withdrawLimitFreqEach': 'Each time',
  'finance.withdrawLimitFreqDaily': 'Daily',
  'finance.withdrawLimitRestrictTitle': 'Withdrawal Restriction',
  'finance.withdrawLimitPwaOnly': 'Withdrawals can only be initiated via PWA',
  'finance.withdrawLimitKycRequired': 'KYC must be completed to initiate withdrawals',
  'finance.withdrawLimitPeerCashout': 'Redirect to TOSPORT to complete withdrawals',
  'finance.withdrawLimitPeerUrlMovedTip':
    'Withdrawal and ticket referral sign-up URLs are now configured per promotion channel. These switches only turn the feature on or off.',
  'finance.withdrawLimitPeerTicketRedirect':
    'Prompt redirect when tickets are insufficient/0 on joining',
  'finance.withdrawLimitPeerRemindPrefix': 'From registration day',
  'finance.withdrawLimitPeerRemindSuffix':
    ', when tickets are 0, prompt redirect to TOSPORT on open, once per day',
  'finance.withdrawLimitPeerRemindEdit': 'Edit',
  'finance.withdrawLimitPeerRemindDayRange': 'Reminder day must be an integer from 0 to 99',
};
